import { INSTANCE, INSTANCELIST } from './API'

const getTypeName = (name) =>
    typeof name === 'string' ? name : name?.en || name?.zh || ''

const sortByName = (results) => {
    results?.list?.sort(function (a, b) {
        const nameA = getTypeName(a?.name).toLowerCase()
        const nameB = getTypeName(b?.name).toLowerCase()
        if (nameA > nameB) return 1
        if (nameA < nameB) return -1
        return 0
    })
    return results
}

export const getProductTypesList = ({ queryKey }) =>
    new Promise((resolve, reject) => {
        const { sort, range, filter, token } = queryKey[1]

        const params = {}
        if (sort) params.sort = JSON.stringify(sort)
        if (range) params.range = JSON.stringify(range)
        if (filter && Object.keys(filter).length) {
            params.filter = JSON.stringify(filter)
        }

        INSTANCELIST({
            method: 'get',
            url: '/product-types',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params,
        })
            .then(sortByName)
            .then(resolve)
            .catch(reject)
    })

export const getSingleProductType = ({ queryKey }) =>
    new Promise((resolve, reject) => {
        const { typeId, token } = queryKey[1]

        INSTANCE({
            method: 'get',
            url: `/product-types/${typeId}`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then(resolve)
            .catch(reject)
    })

export const CreateProductType = (form, token) =>
    new Promise((resolve, reject) => {
        INSTANCE({
            method: 'post',
            url: '/product-types',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            data: JSON.stringify(form),
        })
            .then(resolve)
            .catch(reject)
    })

export const EditProductType = (form, token, typeId) =>
    new Promise((resolve, reject) => {
        INSTANCE({
            method: 'put',
            url: `/product-types/${typeId}`,
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            data: JSON.stringify(form),
        })
            .then(resolve)
            .catch(reject)
    })
